"use strict";
import $ from "jquery";
import * as Pb from "../data/types/Pb";
export function ocrDropZoneClass(componentFlags) {
  const flags = componentFlags.componentFlags;
  switch (flags.type) {
    case Pb.EmbeddedComponentsFlags_ComponentFlagsType.PODDefinition:
      return flags.pod_definition.ocr_drop_zone_class;
    default:
      return null;
  }
}
export function maybeSetupOcrTextDrop(componentFlags, container, elmApp) {
  const dropZoneClass = ocrDropZoneClass(componentFlags);
  if (!dropZoneClass || !container) {
    return null;
  }
  return setupOcrTextDrop(container, elmApp, dropZoneClass);
}
function setupOcrTextDrop(container, elmApp, dropZoneClass) {
  let pointerInsideDropZone = false;
  let trackingPointer = false;
  const pointerInside = (clientX, clientY) => {
    const dropZone = container.querySelector(`.${dropZoneClass}`);
    if (!dropZone) {
      return false;
    }
    const rect = dropZone.getBoundingClientRect();
    return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
  };
  const pointerHandler = (event) => {
    pointerInsideDropZone = pointerInside(event.clientX, event.clientY);
  };
  const stopPointerTracking = () => {
    trackingPointer = false;
    pointerInsideDropZone = false;
    document.removeEventListener("mousemove", pointerHandler);
  };
  const endDrag = () => {
    var _a, _b;
    document.removeEventListener("mouseup", endDrag);
    stopPointerTracking();
    (_b = (_a = elmApp.ports) == null ? void 0 : _a.ocrDragActive) == null ? void 0 : _b.send(false);
  };
  $(container).droppable({
    scope: "dnd-text",
    tolerance: "pointer",
    // Reject drops outside the zone so jQuery UI reverts the token. Until the
    // drag enters and we start tracking, accept anything: dragStart drops any
    // droppable whose accept is false at that moment.
    accept: () => !trackingPointer || pointerInsideDropZone,
    // activate fires whenever a drag starts anywhere in the scope, regardless of
    // pointer position — drives the drop-zone overlay.
    activate: () => {
      var _a, _b;
      document.addEventListener("mouseup", endDrag);
      (_b = (_a = elmApp.ports) == null ? void 0 : _a.ocrDragActive) == null ? void 0 : _b.send(true);
    },
    over: () => {
      trackingPointer = true;
      document.addEventListener("mousemove", pointerHandler);
    },
    out: () => stopPointerTracking(),
    drop: (_event, ui) => {
      var _a, _b;
      stopPointerTracking();
      const chars = ui.helper.data("chars");
      (_b = (_a = elmApp.ports) == null ? void 0 : _a.ocrTextDropped) == null ? void 0 : _b.send(chars == null ? "" : chars.toString());
    }
  });
  return () => {
    stopPointerTracking();
    document.removeEventListener("mouseup", endDrag);
    $(container).droppable("destroy");
  };
}
